import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import { ListDocumentTypesQuery } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';

function DocumentTypeExtraFilter({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListDocumentTypesQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={8} lg={4}>
        <Input
          value={queryParams?.initials}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, initials: value }))
          }
          placeholder={intl.formatMessage({
            id: 'documentTypes.list.header.initials',
          })}
        />
      </Col>

      <Col span={24} md={8} lg={4}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default DocumentTypeExtraFilter;
